import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import React, { useEffect, useState} from "react";
import { AgGridReact } from "ag-grid-react";
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { getexceptionTypes, getExceptionCategory, getExceptionValueTypes, getExceptionNotifCategories, insertOrUpdateExceptionType, getExceptionTypeDetails, deleteExceptionType } from "../../../config/apiConfig";
import { sbaAxios } from "../../utils/sbaAxios";
import { Modal } from "react-bootstrap";
import { SBNotify } from "../../utils/sbNotify";
import { ToastContainer, toast } from 'react-toastify';
import { UrlPath } from "../../../config/routeConfig";
import { useNavigate, useParams } from "react-router-dom";
import { SBADropDown, SBAMultiSelectCheck, SBAComboBox } from "../../UiComponents/SBADropDown";

export const MonitoringExceptionType = () => {
    
    const Level = [{ BreadCrumb: "Admin >", Routes: UrlPath.Admin },{ BreadCrumb: "Monitoring Exception Settings >", Routes: UrlPath.MonitoringExceptionSettings },{ BreadCrumb: "Monitoring Exception Type", Routes: "/" }];
    const [gridata, setGriddata] = useState([]);
    const [showdeleteModal, setShowdeleteModal] = useState(false);
    const [show, setShow] = useState(false); 
    const [Category, setCategory] = useState([]);
    const [NotifCategories, setNotifCategories] = useState([]);
    const [Valuetypes, setValuetypes] = useState([]);
    const [selectedCategory, setselectedCategory] = useState([]);
    const [selectedvaluetype, setselectedvaluetype] = useState([]);
    const [selectedNotifCategories, setselectedNotifCategories] = useState([]);
    const [description, setdescription] = useState([]);
    const [Subject, setSubject] = useState([]);
    const [Message, setMessage] = useState([]);
    const [selectedLinking, setselectedLinking] = useState([]);
    const [selectedTime, setselectedTime] = useState([]);
    const [selectedSeverity, setselectedSeverity] = useState([]);
    const [selectedName, setselectedName] = useState([]);
    const [saveExceptionid, setsaveExceptionid] = useState([]);
    const [selectedNotifytyeId, setselectedNotifytyeId] = useState([]);
    const [isEnabled,setIsEnabled]=useState(false);

    const param=useParams();
    const history = useNavigate();


    useEffect(() => {
        GetExceptionTypes();
        GetCExceptionategory();
        GetExceptionValueTypes();
        GetExceptionNotifCategories();
    }, []) 
 const GetExceptionNotifCategories = async () => {
    try {
        const response = await sbaAxios({

            url: `${getExceptionNotifCategories}`,
            method: 'get',
        })
        if (response) {
            setNotifCategories(response);
        }
    }
    catch (error) {

    }

}
  const GetExceptionValueTypes = async () => {
    try {
        const response = await sbaAxios({

            url: `${getExceptionValueTypes}`,
            method: 'get',
        })
        if (response) {
            setValuetypes(response);
        }
    }
    catch (error) {

    }
  }
    const Addclk = () => {
        setselectedCategory("");
        setselectedvaluetype("");
        setselectedNotifCategories("");
        setdescription("");
        setSubject("");
        setMessage("");
        setselectedLinking("");
        setselectedTime("");
        setselectedSeverity("");
        setselectedName("");
        setsaveExceptionid(0);
        setShow(true);
        setselectedNotifytyeId(0);
        setIsEnabled(val=>false);
    }

    const ExceptionSave = async () => {
        let issave = true;
        const savedata = {
            exceptionTypeId: saveExceptionid,
            exceptionTypeName: selectedName,
            exceptionCategoryId: selectedCategory?.ExceptionCategoryId,
            exceptionValueTypeId: selectedvaluetype?.ExceptionValueTypeId,
            exceptionNotifTypeId: selectedNotifytyeId,
            exceptionNotifCategoryId: selectedNotifCategories?.ExceptionNotifCategoryId,
            description: description || "",
            subject: Subject || "",
            message: Message || "",
            hyperlink: selectedLinking || "",
            timeToLive: parseInt(selectedTime) || 0,
            severity: parseInt(selectedSeverity) || 0,
            isActive:isEnabled
        };

        if (!selectedName) {
            issave = false;
            SBNotify({ Msg: "Please Enter Exception name", type: "error" });
        }
        if (!selectedvaluetype) { 
            issave = false;
            SBNotify({ Msg: "Please Select Exception Value type", type: "error" });
        }
        if (!selectedCategory) {
            issave = false;
            SBNotify({ Msg: "Please select Exception Category name", type: "error" });
        }
        if (!selectedNotifCategories) {
            issave = false;
            SBNotify({ Msg: "Please Select Exception Notification Categories", type: "error" });
        }

        if (issave) {
            try {
                const res = await sbaAxios({
                    url: insertOrUpdateExceptionType,
                    method: "post",
                    data: savedata
                });

                SBNotify({ Msg: "Exception Type Saved Successfully", type: "success" });
                setShow(false);
                GetExceptionTypes();
            } catch (error) {
                console.error("Axios error:", error); 
                SBNotify({ Msg: "Network Error: " + error.message, type: "error" });
            }
        }
    };


    // getExceptionTypeDetails
    const GetExceptionTypeDetails = async (exceptionTypeId,isActive) => {
        try {
            const response = await sbaAxios({

                url: `${getExceptionTypeDetails}/${exceptionTypeId}`,
                method: 'get',
            })
            if (response) {
                setselectedCategory({ ExceptionCategoryId: response.ExceptionCategoryId, ExceptionCategoryName: response.ExceptionCategoryName })
                setselectedvaluetype({ ExceptionValueTypeId: response.ExceptionValueTypeId, ExceptionValueTypeName: response.ExceptionValueTypeName })
                setselectedNotifCategories({ExceptionNotifCategoryId: response.ExceptionNotifCategoryId, ExceptionNotifCategoryName: response.ExceptionNotifCategoryName })
                setdescription(response.Description)
                setSubject(response.Subject)
                setMessage(response.Message)
                setselectedLinking(response.Hyperlink)
                setselectedTime(response.TimeToLive)
                setselectedSeverity(response.Severity)
                setselectedName(response.ExceptionTypeName)
                setIsEnabled(val=>isActive)
                setsaveExceptionid(response.ExceptionTypeId)
                setselectedNotifytyeId( response.ExceptionNotifTypeId)
            }
        }
        catch (error) {

        }

    }
    //Get Grid data
    const GetExceptionTypes = async () => {
        try {
            const response = await sbaAxios({

                url: `${getexceptionTypes}?exceptionTypeId=${null}`,
                method: 'get',
            })
            if (response) {
                setGriddata(response);
            }
        }
        catch (error) {

        }

    }
    //  DeleteExceptionTypeDetails
    const DeleteExceptionTypeDetails = async (exceptionTypeId) => {
        try {
            const response = await sbaAxios({

                url: `${deleteExceptionType}/${exceptionTypeId}`,
                method: 'get',
            })
            if (response) {
                SBNotify({
                    Msg: " Exception Type delete Successfully",
                    type: "success",
                });

                GetExceptionTypes();
            }
            else {

                SBNotify({ Msg: "Exception Type mapped with Tolerance", type: "error" });
            }
        }
        catch (error) {
            SBNotify({ Msg: error, type: "error" });
        }

    }
    const GetCExceptionategory = async () => {

        try {
            const response = await sbaAxios({

                url: `${getExceptionCategory}`,
                method: 'get',
            })
            if (response) {
                setCategory(response);
            }
        }
        catch (error) {
        }
    }
    const ActionRenderer = (props) => {
        const Editdatas = props.data;

        const handleDeleteClick = () => {
            //setShowdeleteModal(true);
            DeleteExceptionTypeDetails(Editdatas.ExceptionTypeId);
        };
        const handleEditClick = () => {
            GetExceptionTypeDetails(Editdatas.ExceptionTypeId,props.data.IsActive);
            setShow(true);
        };
        return (
            <div className="actions-cell">
                <i className="fas fa-trash" style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }} onClick={handleDeleteClick}></i>
                <i
                    className="fas fa-edit"
                    style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }}
                    onClick={handleEditClick}
                ></i>
            </div>
        );
    };
    const HyperlinkRenderer = (props) => {
        const history = useNavigate();
        const handleLinkClick = (event) => {
          history(`${UrlPath.MonitoringNotificationDetails}${props.data.ExceptionNotifTypeId}`);
        };
      
        return (
          <span
            onClick={handleLinkClick}
          >
            {props.value}
          </span>
        );
      };
    const defaultColDef = {
        sortable: false,
        floatingFilter: true,
        suppressMovable: true,
        flex: 1,
        resizable: true
    };
    const Categoryonchange = (e) => {
        setselectedCategory(e.value);

    }
    const ColumnDefs = [
        { headerName: 'Exception Category', field: 'ExceptionCategoryName', filter: "agTextColumnFilter" , cellClass:(e)=>!e.data.IsActive && "text-danger fst-italic"},
        {
            headerName: 'Exception Type',
            field: 'ExceptionTypeName',
            filter: "agTextColumnFilter",
            cellClass:(e)=>!e.data.IsActive && "text-danger fst-italic"
          
        },
        {
            headerName: 'Exception Value Type',
            field: 'ExceptionValueTypeName',
           // cellRenderer: HyperlinkRenderer
            filter: "agTextColumnFilter",
            cellClass:(e)=>!e.data.IsActive && "text-danger fst-italic"
        },
        {
            headerName: 'Action',
            field: 'Action',
            cellRenderer: ActionRenderer,
             filter: "agTextColumnFilter"
            
        }
    ];
    return <>
        <div className="row">
            <div class="col-lg-12 col-md-12 bg-white  rounded">
                <div className="d-flex justify-content-end gap-2">
                    <button className="p-sm-btn mx-1" onClick={Addclk}>
                        <i className="fa-solid fa-plus" /> Add
                      </button>
            
                     </div>
                       <div className="ag-theme-alpine mt-3" style={{ height: "70vh", width: "100%" }}>
                                <AgGridReact suppressScrollOnNewData rowData={gridata} columnDefs={ColumnDefs} defaultColDef={defaultColDef}/>
                       </div>
            </div> 
            <SBADrawer
                open={show}
                setOpen={setShow}
                close={false}
                title={"Add /Edit Exception Type "}
            >
                <div className="drawer">
                    <div>
                        <div className="col-lg-12 px-0">
                            <div className="row m-2">
                            <div className="col-md-5">
                                <div className="col-auto ">
                                    <input
                                        type="checkbox"
                                        checked={isEnabled}
                                        onChange={() => {
                                            setIsEnabled(val=>!val);
                                        }}
                                    />
                                    <span className="fw-medium ps-4 me-2" >Enabled</span>
                                </div>
                            </div>
                                <div className="row mb-4">                                    
                                        <label className="header-container m-1">
                                            Name
                                          </label>
                                        <div>
                                            <input
                                                className="form-control w-100"
                                                type="text"
                                               value={selectedName}
                                               onChange={(e) => setselectedName(e.target.value)}

                                            />
                                        </div>                                  
                                </div>
                                <div className="row mb-4">
                                    <div className="col-md-6">
                                        <label className="header-container m-1">Value Type</label>
                                        <div>
                                            <SBAComboBox
                                                className="w-100"
                                                popupSettings={{ className: "modalDD" }}
                                                data={Valuetypes}
                                                textField={"ExceptionValueTypeName"}
                                                valueField={"ExceptionValueTypeId"}
                                                value={selectedvaluetype}
                                                onChange={(e) => { setselectedvaluetype(e.value)}}
                                                placeholder="---Please Select---"
                                                                                               
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <label className="header-container m-1">Category</label>
                                        <div>
                                            <SBAComboBox
                                                className="w-100"
                                                data={Category}
                                                textField={"ExceptionCategoryName"}
                                                valueField={"ExceptionCategoryId"}
                                                value={selectedCategory}
                                                onChange={Categoryonchange}
                                                placeholder="---Please Select---"
                                                popupSettings={{ className: "modalDD" }}

                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-4">

                                    <div className="h5 mb-3">
                                        Notification Info
                                     </div>
                                  
                                    <div className="col-md-6">
                                    <label className="header-container m-1">Notification Category</label>

                                        <div>
                                            <SBAComboBox
                                                className="w-100"
                                                data={NotifCategories}
                                                textField={"ExceptionNotifCategoryName"}
                                                valueField={"ExceptionNotifCategoryId"}
                                                value={selectedNotifCategories}
                                                onChange={(e) => { setselectedNotifCategories(e.value) }}
                                                placeholder="---Please Select---"
                                                popupSettings={{ className: "modalDD" }}

                                            />
                                        
                                        </div>
                                    </div>
                                    <div className="col-md-6">

                                    </div>
                                </div>

                                    <div className="row mb-4">
                                   
                                        <label className="header-container m-1">
                                            Description
                                          </label>
                                        <div>
                                            <input
                                                className="form-control w-150"
                                                type="text"
                                                value={description}
                                                onChange={(e) => setdescription(e.target.value)}

                                            />
                                        </div>
                                    
                                    </div>

                                    <div className="row mb-4">
                                   
                                    <label className="header-container m-1">Subject</label>
                                        <div className="d-flex gap-2">
                                            <input
                                                className="form-control w-150"
                                                type="text"
                                                value={Subject}
                                                onChange={(e) => setSubject(e.target.value)}

                                            />
                                        </div>
                                       

                                    </div>
                                
                                <div className="row mb-4">
                                                                      
                                        <label className="header-container m-1">
                                          Message
                                          </label>
                                        <div>
                                            <textarea id="txtNote" className="form-control h-100" rows={6}
                                                onChange={(e) => setMessage(e.target.value)}
                                                value={Message}
                                            >
                                            </textarea>
                                        </div>                               
                                </div>
                                <div className="row mb-4">
                                    <label className="header-container m-1">
                                        Hyper Link
                                          </label>
                                    <div>
                                        <input
                                            className="form-control w-100"
                                            type="text"
                                            value={selectedLinking}
                                            onChange={(e) => setselectedLinking(e.target.value)}
                                        />
                                    </div>
                                </div>


                                <div className="row mb-4">
                                    <div className="col-md-6">
                                        <label className="header-container m-1">
                                            Time to Live
                                          </label>
                                        <div>
                                            <input
                                                className="form-control w-100"
                                                type="number"
                                                value={selectedTime}
                                                onChange={(e) => setselectedTime(e.target.value)}

                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">

                                        <label className="header-container m-1">
                                           Severity
                                          </label>
                                        <div>
                                            <input
                                                className="form-control w-100"
                                                type="number"
                                               value={selectedSeverity}
                                                onChange={(e) => setselectedSeverity(e.target.value)}

                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="mb-4 m-1 d-flex justify-content-end mt-2">
                                        <button className="s-sm-btn mx-1" onClick={() => {
                                            setShow(false);
                                        }}>
                                            Cancel
                            </button>
                                        <button className="p-sm-btn mx-1" onClick={ExceptionSave}>
                                            Save
                           </button>

                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </SBADrawer>

            {/*  Delete Modal ----- */}
            <Modal show={showdeleteModal}>
                <Modal.Header
                    closeButton
                    onClick={() => {
                        setShowdeleteModal(false);
                    }}
                >
                    <Modal.Title>
                        Delete Exception Type
          </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Do you want delete this Exception Type?</p>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="s-sm-btn mx-1"
                        onClick={() => {
                            setShowdeleteModal(false);
                        }}
                    >
                        Cancel
                       </button>
                    <button
                        className="p-sm-btn mx-1"
                        //onClick={Deletesettings}
                    >
                        Yes
                    </button>
                </Modal.Footer>
            </Modal>
            {/*<ToastContainer></ToastContainer>*/}
        </div>
    
        
    </>

}

export const getCurrencyFormat = (number, decimalnumber = 2, currencyCode = 'USD', locale = 'en-US') => {
    try {
      if (number == null || Number(number) === 0 || isNaN(Number(number))) {
        return '';
      }
      const decimalPlaces = Math.max(0, parseInt(decimalnumber, 10) || 0);
  
      const formattedCurrency = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
      }).format(Number(number));
  
      return formattedCurrency;
    } catch (error) {
      console.error('Error formatting currency:', error);
      return '';
    }
  };
  